<template lang="html">

  <section class="wrapper ofertas-view">

    <div class="container">

      <buscador @set="setbuscador" :length="ofertasfiltered.length" :lengthbydomain="lengthbydomain"></buscador>

      <section class="listado-ofertas" v-if="ofertas.length > 0">

        <oferta :data="oferta" :key="key" v-for="(oferta,key) in actualPage"></oferta>
        <h3 v-if="ofertasfiltered.length == 0" class="no-result">No se han encontrado ofertas</h3>

        <nav class="paginador row-center" v-if="ofertasfiltered.length > 10">
          <button @click="prevPage" v-if="page != 0">
            <</button> <button v-if="inrange(n)" @click="setPage(n)" :active="n == page+1" v-for="n in pages">{{n}}
          </button>
          <button @click="nextPage" v-if="page != pages-1">></button>
        </nav>

      </section>
      <div class="loading" v-else></div>

    </div>

  </section>

</template>

<script lang="js">

  import oferta from '@/components/parts/oferta-el';

  import buscador from '@/components/parts/buscador-ofertas';

  import { mapActions, mapGetters } from 'vuex';
  
  import router from '@/router';

  export default {
    name: 'ofertas',
    mounted() {
      if (this.ofertas.length == 0) {
        this.requestFirstsOfertas();
      }

      (!!this.$route.params.page) ? this.page = Number(this.$route.params.page) - 1 : '';

    },
    data() {
      return {
        buscador: {
          areafuncional: [],
                    sectores: [],
                    ubicacion: [],
                    contratos: [],
                    experiencia : [],
                    fechapublicacion: '',
                    palabrasclave: '',
        },
        perpage: 10,
        page: 0,
        init : true
      }
    },
    methods: {
      ...mapActions(['requestFirstsOfertas']),
      setbuscador(value) {

        if((JSON.stringify(this.buscador) != JSON.stringify(value)) && !this.init){
          this.page = 0;
          this.$router.replace({ name: "ofertas" });
        }

        this.init = false;
        
        this.buscador = JSON.parse(JSON.stringify(value));
        
        
      },
      nextPage() {
        if (this.page <= this.pages) {
          this.page++;
          this.up();
        }
      },
      prevPage() {
        if (this.page >= 1) {
          this.page--;
          this.up();
        }
      },
      setPage(n) {
        this.page = n - 1;
        this.up();
      },
      up() {
        $('html,body').animate({ scrollTop: 0 }, 400);
        this.$router.replace({ name: "ofertas", params: { page: this.page + 1 } });
      },
      inrange(n) {
        let can = false;

        if (n > this.page) {
          can = (n < this.page + 5);
        } else {
          can = (n > this.page - 3);
        }

        return can;

      },
      filterwithouttype(type) {

        let ofertas;

        if (!!this.ofertas) {

          ofertas = this.ofertas;


          if(type != 'areafuncional'){
          if (!!this.buscador.areafuncional && this.buscador.areafuncional.length > 0) {
            ofertas = ofertas.filter(o => {
              return (this.buscador.areafuncional.some(id => Number(id) == o.areaFuncional));
            });
          }
          }

          if(type != 'sectores'){
          if (!!this.buscador.sectores && this.buscador.sectores.length > 0) {
            ofertas = ofertas.filter(o => {
              return (this.buscador.sectores.some(id => Number(id) == o.idSectorOferta));
            });
          }
          }

          if(type != 'contratos'){
          if (!!this.buscador.contratos && this.buscador.contratos.length > 0) {
            ofertas = ofertas.filter(o => {
              return (this.buscador.contratos.some(id => Number(id) == o.contrato));
            });
          }
          }


          if(type != 'experiencia'){
          if (!!this.buscador.experiencia && this.buscador.experiencia.length > 0) {
            ofertas = ofertas.filter(o => {
              return (this.buscador.experiencia.some(id => Number(id) == o.experiencia));
            });
          }
          }

          if(type != 'ubicacion'){  
          if (!!this.buscador.ubicacion && this.buscador.ubicacion.length > 0) {
            ofertas = ofertas.filter(o => {
              return (this.buscador.ubicacion.some(ubicacion => ubicacion == o.provincia));
            });
          }
          }

          if(type != 'fechapublicacion'){
          if (!!this.buscador.fechapublicacion) {
            ofertas = ofertas.filter(o => {
              let fechaoferta = o.fecha.split("/");
              let fecha = new Date(fechaoferta[2],Number(fechaoferta[1])-1, fechaoferta[0]).getTime();
              return (fecha >= this.buscador.fechapublicacion);
            });
          }
          }

          if (!!this.buscador.palabrasclave && type != 'palabrasclave') {

            let searchIn = ['titulo', 'descripcion','idoferta'];

            ofertas = ofertas.filter(o => {
              let can = false;
              searchIn.forEach(c => {
                if (o[c].toLowerCase().includes(this.buscador.palabrasclave.toLowerCase())) {
                  can = true;
                }
              });
              return can;
            })
          }

        }

        return ofertas;

      },
    },
    components: {
      oferta,
      buscador
    },
    computed: {
      ...mapGetters({
        ofertas: 'getOfertas',
        dominios: 'getDominios',
        ubicaciones: 'getubicaciones'
      }),
      ofertasfiltered() {

        let ofertas;

        if (!!this.ofertas) {

        ofertas = this.filterwithouttype();
      

        }

        return ofertas;

      },
      pages() {
        let nofertas = this.ofertasfiltered.length;
        return Math.ceil(nofertas / this.perpage);
      },
      actualPage() {

        let ofertas;

        let inicio = this.perpage * this.page;

        let fin = inicio + this.perpage;

        if (!!this.ofertasfiltered) {
          ofertas = this.ofertasfiltered.slice(inicio, fin);
        }

        return ofertas;
      },
      
      lengthbydomain() {

        let domains = ['areafuncional', 'contratos', 'sectores','experiencia'];

        let lengthbydomain = new Object();

        let ofertas;

        //Relaciona los dominios con el id del campo de la oferta
        let relations = {
          'areafuncional': 'areaFuncional',
          'contratos': 'contrato',
          'sectores': 'idSectorOferta',
          'experiencia' : 'experiencia'
        }

        domains.forEach(type => {

          ofertas = this.filterwithouttype(type);

          lengthbydomain[type] = new Object();

          Object.keys(this.dominios[type]).forEach(id => {
              lengthbydomain[type][id] = ofertas.filter(o => o[[relations[type]]] == id).length;
          })

        }); 

        if(this.ubicaciones.length > 0){

          lengthbydomain['ubicaciones'] = new Object();

          ofertas = this.filterwithouttype('ubicacion');    

          this.ubicaciones.forEach(u => {
            lengthbydomain['ubicaciones'][u] = ofertas.filter(o => u == o.provincia).length;
          })

        }


        lengthbydomain['fechapublicacion'] = new Object();

        ofertas = this.filterwithouttype('fechapublicacion');

        Object.entries(this.fechas).forEach(f => {
          lengthbydomain['fechapublicacion'][f[0]] = ofertas.filter(o => {
              let fechaoferta = o.fecha.split("/");
              let fecha = new Date(fechaoferta[2],Number(fechaoferta[1])-1, fechaoferta[0]).getTime();
              return (fecha >= Number(f[1]));
            }).length;
        });

        return lengthbydomain;

      },
      fechas() {
                let actual = new Date().getTime();
                const SEMANAVAL = 604800000;
                return {
                    "actual": 0,
                    "semana": (actual - SEMANAVAL),
                    "quincena": (actual - SEMANAVAL * 2),
                    "mes": (actual - SEMANAVAL * 4),
                }
      }
    }
  }
</script>

<style scoped lang="scss">
  .no-result {
    margin-bottom: 0;
  }
</style>


// WEBPACK FOOTER //
// src/components/views/ofertas.vue